'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MPPHeaderRoot = require('./../../header/jsx/components/MPPHeaderRoot');

var _MPPHeaderRoot2 = _interopRequireDefault(_MPPHeaderRoot);

var _GlobalHeader2 = require('../../header/jsx/v1/GlobalHeader');

var _GlobalHeader3 = _interopRequireDefault(_GlobalHeader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPCustomHeader = function (_GlobalHeader) {
  _inherits(MPPCustomHeader, _GlobalHeader);

  function MPPCustomHeader() {
    _classCallCheck(this, MPPCustomHeader);

    return _possibleConstructorReturn(this, (MPPCustomHeader.__proto__ || Object.getPrototypeOf(MPPCustomHeader)).apply(this, arguments));
  }

  _createClass(MPPCustomHeader, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var clickHandlers = {
        handleMenuButton: this.handleMenuButton,
        handleMainLinks: this.handleMainLinks,
        openHeader: this.openHeader,
        closeHeader: this.closeHeader,
        openSubnav: this.openSubnav,
        closeSubnav: this.closeSubnav
      };

      return _react2.default.createElement(_MPPHeaderRoot2.default, {
        className: this.props.className,
        getHeaderRef: function getHeaderRef(domNode) {
          _this2.headerRef = domNode;
        },
        content: this.props.content,
        config: this.props.config,
        menuOpen: this.state.isOpen,
        isClosing: this.state.isClosing,
        register: this.registerDropDown,
        activeLink: this.state.activeLink,
        activeLinkIndex: this.state.activeLinkIndex,
        closingLinkIndex: this.state.closingLinkIndex,
        handlers: clickHandlers
      });
    }
  }]);

  return MPPCustomHeader;
}(_GlobalHeader3.default);

exports.default = MPPCustomHeader;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/custom-header/jsx/MPPCustomHeader.js
// module id = 497
// module chunks = 4